import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { Alpha1Set, ModalcolorSet, PromodeSet, Ratio1Set } from "../App";
import { FunkMovebyKey } from "../coreCesium/funcMovebyKey";
import Csv2kml from "../makekml/csv2kml";
// import { ButtonAlpha } from "./buttonAlpha";
// import { ButtonRatio } from "./buttonRatio";
// import { HanreiHigh } from "./hanreiHigh";
// import { HanreiNormal } from "./hanreiNormal";
// import { FunkMoveby3Dmouse } from "../aDev/funcMoveby3Dmouse";
import { Cesium1Set } from "../App";
import DataSelection from "./DataSelection";

export const DaiproFooter = ({ metadata }) => {
  const [footerview, setFooterview] = useState(true);
  const { ratio1set } = useContext(Ratio1Set);
  const { alpha1set } = useContext(Alpha1Set);
  const { modalcolorset, setModalcolorSet } = useContext(ModalcolorSet);
  const { promodeset, setPromodeSet } = useContext(PromodeSet);

  const { cesium1set, setCesium1Set } = useContext(Cesium1Set);

  const handleChangerepeat = () => {
    setFooterview(!footerview);
  };
  const handleChangepromode = () => {
    setPromodeSet(!promodeset);
  };
  const handleModalcolor = () => {
    setModalcolorSet(true);
    console.log("クリック");
  };
  const params = useParams();

  return (
    <>
      <div
        className={`absolute bottom-0 z-30 pointer-events-none md:rounded-xl bg-blue-500 ${
          footerview ? "animate-fade-in-up" : "animate-fade-in-down"
        }`}
        x-data="app"
      >
        <div className="pointer-events-auto">
          <input
            name="footer"
            id="フッタ表示"
            type="checkbox"
            // value="フッタ表示"
            onChange={handleChangerepeat}
            checked={false == footerview}
            className="peer hidden"
          />
          {footerview ? (
            <label
              htmlFor="フッタ表示"
              className={`block cursor-pointer select-none md:rounded-sm text-center text-xl md:text-3xl lg:text-4xl bg-gray-200 text-black`}
            >
              ▼
            </label>
          ) : (
            <label
              htmlFor="フッタ表示"
              className={`block cursor-pointer select-none md:rounded-sm text-center text-xs md:text-sm lg:text-base peer-checked:bg-blue-500 peer-checked:text-white`}
            >
              ▲表示する
            </label>
          )}
        </div>
      </div>
      <div>
        <div
          className={`absolute bottom-0 left-32 z-30 pointer-events-auto md:rounded-sm bg-blue-500 ${
            footerview ? "animate-fade-in-up" : "animate-fade-in-down"
          }`}
          x-data="app"
        >
          <div className="flex pointer-events-auto">
            {footerview ? (
              <></>
            ) : (
              <>
                <input
                  id="prochk"
                  type="checkbox"
                  onChange={handleChangepromode}
                  checked={promodeset}
                />
                <label
                  htmlFor="prochk"
                  className={`block cursor-pointer md:rounded-sm text-center text-xs md:text-sm lg:text-base bg-blue-500 text-white`}
                >
                  Proモード(試験中)
                </label>
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className={`absolute z-20 bottom-0  text-black-900 py-1 text-center bg-gradient-to-r from-white/90 via-white/70 to-white/30 pointer-events-none ${
          footerview ? "animate-fade-in-up" : "animate-fade-out-down"
        }`}
      >
        <div className={`flex md:justify-center w-full pointer-events-none`}>
          <div className="w-12/12 md:w-12/12 z-20 pointer-events-auto overflow-y-auto h-[32rem]">
            <DataSelection setFooterview={setFooterview} />
          </div>
          {/* <div className="w-1/12 flex justify-center my-auto pointer-events-auto">
          </div> */}

          {/* {promodeset && (
            <div className="w-2/12 flex justify-center my-auto pointer-events-auto">
            </div>
          )}

          {promodeset && (
            <></>
          )} */}

          {/* {promodeset && <FunkMovebyKey rfcs={cesium1set} />} */}

          {/* <FunkMoveby3Dmouse rfcs={cesium1set} /> */}
          {/* <FuncMoveby3dHyper rfcs={cesium1set} /> */}

          {/* <div className="w-3/12 md:w-3/12 flex justify-center pointer-events-none">
            <div
              className="flex justify-center md:rounded-xl bg-gray-200 md:p-2 my-auto"
              x-data="app"
            >
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};
